/**
 * calcWallpaper.js
 * 壁紙の必要メートル数を計算する関数
 * Shopify assets/ に配置し、Sectionから読み込んで使用する
 */
 
function calcWallpaper() {
  var wallpaperWidth = parseFloat(document.getElementById('wallpaperWidth').value);
  var roomWidth      = parseFloat(document.getElementById('roomWidth').value);
  var roomHeight     = parseFloat(document.getElementById('roomHeight').value);
 
  var errorBox  = document.getElementById('calcError');
  var resultBox = document.getElementById('resultBox');
 
  // バリデーション
  if (!wallpaperWidth || !roomWidth || !roomHeight ||
      wallpaperWidth <= 0 || roomWidth <= 0 || roomHeight <= 0) {
    errorBox.style.display  = 'block';
    resultBox.style.display = 'none';
    return;
  }
 
  errorBox.style.display = 'none';
 
  // 上下の切りしろ（各5cm）を高さに加算
  var heightWithMargin = roomHeight + 10;
 
  // 横に何枚必要か（切り上げ）
  var sheets = Math.ceil(roomWidth / wallpaperWidth);
 
  // 合計の長さ（cm）
  var totalCm = sheets * heightWithMargin;
 
  // 2割ロスを加算
  var totalWithLoss = totalCm * 1.2;
 
  // メートルに変換して切り上げ（1m単位）
  var totalM = Math.ceil(totalWithLoss / 100);
 
  document.getElementById('resultLength').textContent = totalM;
  resultBox.style.display = 'block';
 
  // 結果へスクロール
  resultBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
 